import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ContactsPage from "./pages/ContactsPage";
import BroadcastPage from "./pages/BroadcastPage";
import BroadcastHistoryPage from "./pages/BroadcastHistoryPage";
import InboxPage from "./pages/InboxPage";
import Layout from "./components/Layout";
import Login from "./pages/loginPage";
import GroupsPage from "./pages/GroupPage";
import ProtectedRoute from "./components/ProtectedRoute";
import TemplatesPage from "../src/pages/templatesPage"
import ResetPassworrd from "../src/pages/passwordRest";
import AddTemplatePage from "./pages/addTemplatePage";
import "./App.css";

function App() {
  const token = localStorage.getItem("token");

  return (
    <Router>
      <Routes>

        <Route
          path="/login"
          element={token ? <Navigate to="/" replace /> : <Login />}
        />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ContactsPage />} />
          <Route path="broadcasts" element={<BroadcastPage />} />
          <Route path="broadcast-history" element={<BroadcastHistoryPage />} />
          <Route path="inbox" element={<InboxPage />} />
          <Route path="groups" element={<GroupsPage />} />
          <Route path="templates" element={<TemplatesPage />} />
          <Route path="addtemplate" element={<AddTemplatePage />} />
          <Route path="passwordrest" element={<ResetPassworrd />} />
        </Route>

        <Route path="*" element={<Navigate to={token ? "/" : "/login"} replace />} />

      </Routes>
    </Router>
  );
}

export default App;
